<p *ngIf="!_hide && _enabled"
   [ngClass]="{visible: !_hide}"
   class="tft-control-error" >
  {{ _text }}
</p>
